export default "__VITE_ASSET__88f901e5__"